type SocialBrandIconProps = {
  className?: string;
};

export function FacebookBrandIcon({ className }: SocialBrandIconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
    >
      <path d="M13.5 3.5H16V0h-2.5C10.9 0 9 1.9 9 4.5V7H6v3.5h3V24h3.5v-13.5H16l.5-3.5h-3V4.9c0-1 .8-1.4 1.5-1.4Z" />
    </svg>
  );
}

export function YelpBrandIcon({ className }: SocialBrandIconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
    >
      <path d="M12.27 1.73c-.17-.01-.34.02-.5.08l-2.8 1.02c-.47.17-.78.62-.78 1.12v3.05L5.8 4.9a1.1 1.1 0 0 0-1.45.05l-2.2 2.05a1.1 1.1 0 0 0-.12 1.38l2.05 2.65-3.1-.9a1.1 1.1 0 0 0-1.18.38l-1.4 2.15a1.1 1.1 0 0 0 .28 1.42l2.75 1.95 3.35-1.05-1.35 3.05a1.1 1.1 0 0 0 .62 1.45l2.45.85a1.1 1.1 0 0 0 1.35-.62l1.35-3.05 1.35 3.05a1.1 1.1 0 0 0 1.35.62l2.45-.85a1.1 1.1 0 0 0 .62-1.45l-1.35-3.05 3.35 1.05 2.75-1.95a1.1 1.1 0 0 0 .28-1.42l-1.4-2.15a1.1 1.1 0 0 0-1.18-.38l-3.1.9 2.05-2.65a1.1 1.1 0 0 0-.12-1.38l-2.2-2.05a1.1 1.1 0 0 0-1.45-.05l-2.42 1.98V2.83c0-.5-.31-.95-.78-1.12l-2.8-1.02a1.1 1.1 0 0 0-.73 0Z" />
    </svg>
  );
}

export function XBrandIcon({ className }: SocialBrandIconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.558-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644Z" />
    </svg>
  );
}

export function PinterestBrandIcon({ className }: SocialBrandIconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
    >
      <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.403.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0Z" />
    </svg>
  );
}

export function TikTokBrandIcon({ className }: SocialBrandIconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
    >
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.77 1.52V6.76a4.85 4.85 0 0 1-1-.07Z" />
    </svg>
  );
}

export function GoogleBrandIcon({ className }: SocialBrandIconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
    >
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09Z" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23Z" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62Z" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53Z" />
    </svg>
  );
}
